import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';

import React, { useEffect, useState } from 'react';

interface IWeekDaysCompProps {
	handleWeekDays: (val: string) => void;
}

type OptionType = {
	value: string;
	label: string;
	checked: boolean;
};

const daysList: OptionType[] = [
	{ label: 'Monday', value: 'Monday', checked: false },
	{ label: 'Tuesday', value: 'Tuesday', checked: false },
	{ label: 'Wednesday', value: 'Wednesday', checked: false },
	{ label: 'Thursday', value: 'Thursday', checked: false },
	{ label: 'Friday', value: 'Friday', checked: false },
	{ label: 'Saturday', value: 'Saturday', checked: false },
	{ label: 'Sunday', value: 'Sunday', checked: false },
];

const WeekDaysComp = (props: IWeekDaysCompProps) => {
	const { handleWeekDays } = props;
	const [daysofWeek, setDaysOfWeek] = useState<OptionType[]>(daysList);

	const handleCheckboxEvent = (event: React.ChangeEvent<HTMLInputElement>) => {
		setDaysOfWeek((prevState: any) => {
			const data = [...prevState];
			const updatedData = data.map((d) =>
				d.value === event.target.value
					? { ...d, checked: event.target.checked }
					: d,
			);
			return updatedData;
		});
	};

	useEffect(() => {
		if (daysofWeek) {
			const days = daysofWeek
				.filter((d) => d.checked)
				.map((d) => d.value)
				.toString();
			if (days.length) {
				handleWeekDays(days);
			}
		}
	}, [daysofWeek]);

	return (
		<Box sx={{ flexGrow: 1 }}>
			<Grid
				container
				spacing={{ xs: 2, md: 2 }}
				columns={{ xs: 4, sm: 2, md: 12 }}
			>
				{daysofWeek &&
					daysofWeek.map(({ label, value }) => (
						<Grid item xs={2} sm={3} md={3} key={label}>
							<FormControlLabel
								value={value}
								control={<Checkbox onChange={handleCheckboxEvent} />}
								label={label}
								labelPlacement="end"
							/>
						</Grid>
					))}
			</Grid>
		</Box>
	);
};

export default WeekDaysComp;
